import React from 'react';
import classes from './pdfHeading.module.css';
import logo from '../../../../../../assets/hf-logo-2022-horiz-new.png';

function PdfHeading(_ref) {
  var showContactInfo = _ref.showContactInfo,
      pdfOptions = _ref.pdfOptions,
      documentTitle = _ref.documentTitle,
      index = _ref.index;

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '+1 (' + match[1] + ')-' + match[2] + '-' + match[3];
    return null;
  }

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: classes.logoWrapper
  }, React.createElement("img", {
    src: logo,
    alt: "Hubbardton Forge logo"
  })), showContactInfo && index === 0 ? React.createElement("div", {
    className: classes.contactInfo
  }, React.createElement("div", {
    className: "flex justify-between"
  }, React.createElement("p", {
    className: "flex-1 mb-0"
  }, pdfOptions === null || pdfOptions === void 0 ? void 0 : pdfOptions.name), React.createElement("p", {
    className: "flex-1 mb-0 text-center"
  }, documentTitle), React.createElement("p", {
    className: "flex-1 mb-0 text-right mb-[15px]"
  }, pdfOptions === null || pdfOptions === void 0 ? void 0 : pdfOptions.email)), React.createElement("div", {
    className: "flex justify-between"
  }, React.createElement("p", {
    className: ""
  }, pdfOptions === null || pdfOptions === void 0 ? void 0 : pdfOptions.companyName), React.createElement("p", null, formatPhoneNumber(pdfOptions === null || pdfOptions === void 0 ? void 0 : pdfOptions.phone)))) : null);
}

export default PdfHeading;